import {getQueryClient} from '@github-ui/query-client'
import {ISSUES_DASHBOARD_PATH} from '../constants/routes'
import {issuesDashboardSurfaceLayoutRoute} from '../routes/issues-dashboard-surface-layout-route'

import type {IssuesDashboardLayoutPayload} from '../types/routes-types'
import type {SidebarLink} from '@github-ui/saved-views'

function issuesQueryMap(): Record<string, string> {
  return {
    assigned: 'is:issue state:open archived:false assignee:@me sort:updated-desc',
    created: 'is:issue state:open archived:false author:@me sort:updated-desc',
    mentioned: 'is:issue state:open archived:false mentions:@me sort:updated-desc',
    recent: 'is:issue involves:@me updated:>@today-1w sort:updated-desc',
  }
}

function getIssuesLayoutQueryKey() {
  return issuesDashboardSurfaceLayoutRoute.queries.mainQuery.makeQueryKey({
    pathname: `${ISSUES_DASHBOARD_PATH}/_layout`,
  })
}

function savedViewQuery(mode: string): string | undefined {
  const raw: {payload?: IssuesDashboardLayoutPayload} | undefined =
    getQueryClient().getQueryData(getIssuesLayoutQueryKey())
  const savedViews = raw?.payload?.savedViews
  if (!savedViews) return undefined
  const view = savedViews.find(v => v.id.toString() === mode || v.globalId === mode)
  return view?.query
}

export function updateCachedIssuesSavedViews(updatedSavedViews: SidebarLink[]) {
  const queryKey = getIssuesLayoutQueryKey()
  getQueryClient().setQueryData(queryKey, (old: {payload?: IssuesDashboardLayoutPayload} | undefined) => {
    if (!old?.payload) return old
    return {...old, payload: {...old.payload, savedViews: updatedSavedViews}}
  })
}

export const issuesQueryResolver = ({
  searchParams,
  params,
}: {
  searchParams: URLSearchParams
  params: {mode?: string}
}): string => {
  const map = issuesQueryMap()
  if (searchParams.get('q')) {
    return searchParams.get('q') as string
  } else if (params.mode && map[params.mode]) {
    return map[params.mode] as string
  } else if (params.mode) {
    return savedViewQuery(params.mode) ?? ''
  }
  return ''
}
